import reducerRegistry from './ReducerRegistry';
const reducer = (state = { modal: false }, action) => {
    switch (action.type) {
        case 'APPLICATION_MODAL': {
            const newState = Object.assign(Object.assign({}, state), { modal: action.modal ? action.modal : false, modalId: action.itemId, modalName: action.itemName });
            if (action.data) {
                newState.modalData = action.data;
            }
            return newState;
        }
        case 'APPLICATION_MESSAGE': {
            const messages = state.messages ? state.messages.slice() : [];
            // Always put errors in front of the array.
            if (action.severity === 'error') {
                messages.unshift({
                    message: action.message,
                    severity: action.severity
                });
            }
            else {
                messages.push({
                    message: action.message,
                    severity: action.severity
                });
            }
            return Object.assign(Object.assign({}, state), { messages });
        }
        case 'APPLICATION_CLOSE_MESSAGE': {
            const newMessages = state.messages ? state.messages.slice() : [];
            if (newMessages.length > 0) {
                newMessages.shift();
            }
            return Object.assign(Object.assign({}, state), { messages: newMessages });
        }
        case 'TOGGLE_CONDITIONS': {
            const acceptedConditions = Object.assign(Object.assign({}, state.acceptedConditions), { [action.modalKey]: action.accepted });
            return Object.assign(Object.assign({}, state), { acceptedConditions });
        }
        default:
            return state;
    }
};
reducerRegistry.register('application', reducer);
